import i18n from "i18next";
import { I18nextProvider, initReactI18next } from "react-i18next";

import { createContext, useEffect, useRef, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import MyRouter from "routers/index";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          "Découvrez nos partenaires": "Discover our partners",
          "Abonnement": "Subscription",
          "Choisir": "Choose"
        }
      },
      fr: {
        translation: {
          "Découvrez nos partenaires": "Découvrez nos partenaires",
          "Abonnement": "Abonnement",
          "Choisir": "Choisir"
        }
      },
      ar: {
        translation: {
          "Découvrez nos partenaires": "اكتشف شركائنا",
          "Abonnement": "الاشتراك",
          "Choisir": "اختار"

        }
      }
      
    },
    lng: `${localStorage.getItem('lng') ? localStorage.getItem('lng') : 'fr'}` , // if you're using a language detector, do not define the lng option
    fallbackLng: "fr",

  });
type WebsocketContextType = {
  ready:any;
  value:any;
  send:any
}

const defaultState = {
  ready: false,
  value: null,
  send: () => {}
};

export const WebsocketContext = createContext<WebsocketContextType>(defaultState);

export interface WebsocketProviderType {
  children:any
}

export const WebsocketProvider = ({ children }:WebsocketProviderType) => {
  const [isReady, setIsReady] = useState(false);
  const [val, setVal] = useState(null);

  const ws = useRef<any>();

  useEffect(() => {
    const loginData = localStorage.getItem('loginData')
    ? JSON.parse(localStorage.getItem('loginData')!)
    : {
      authChecked: false,
      loggedIn: false,
      token: ""
    }
    // document.cookie = `X-Authorization=${loginData.token}; path=/`;
    const socket = new WebSocket("wss://roupadz.com/api/ws/message");

    socket.onopen = () => setIsReady(true);
    socket.onclose = () => setIsReady(false);
    socket.onmessage = (event) => setVal(event.data);

    ws.current = socket;

    return () => {
      socket.close();
    };
  }, []);

  // const ret = [isReady, val, ws.current?.send.bind(ws.current)];
  const ret = {
    ready: isReady,
    value: val,
    send: ws.current?.send.bind(ws.current)
  };

  return (
    <WebsocketContext.Provider value={ret} >
      {children}
    </WebsocketContext.Provider>
  );
};
// export const WsConsumer = () => {
//   const ret = useContext(WebsocketContext); // use it just like a hook

//   useEffect(() => {
//     if (ret.ready) {
//       ret.send("test message");
//     }
//   }, [ret.ready, ret.send]); // make sure to include send in dependency array

//   return (
//     <div>
//       Ready: {JSON.stringify(ret.ready)}, Value: {ret.value}
//     </div>
//   );
// };

function App() {

  
  return (
    <HelmetProvider>
      <Helmet>
        <title>Roupa</title>
        <meta
          name="description"
          content="Roupa || Shop - eCommerce "
        />
      </Helmet>

      {/* MAIN APP */}
      <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
        <WebsocketProvider>
        <I18nextProvider i18n={i18n} >
          <MyRouter />
        </I18nextProvider>
        </WebsocketProvider>
        
      </div>
    </HelmetProvider>
  );
}

export default App;
